module.exports = __webpack_public_path__ + "img/blog.61d895b9.png";